import { EventEmitter } from 'events'
import Payment from '@/api/payment'
import { hasCordova } from './cordova'

export default class InAppPurhcase extends EventEmitter {
  static refreshedStore: boolean = false

  /**
   * アプリ課金データの取得
   */
  async fetchAppPayment() {
    if (!hasCordova) {
      return
    }

    const data = await Payment.fetchAppPayment({
      page: 'get_init',
      os: cordova.platformId,
      app: '1'
    })
    if (data.error) {
      return Promise.reject(data.error)
    }
    return data
  }

  /**
   * アプリ内課金初期化
   */
  init(menus: any) {
    console.log('[inapp-purchase init]')
    store.verbosity = store.DEBUG
    store.validator = this.validator.bind(this)

    const ids = Object.keys(menus)
    for (const id of ids) {
      store.register({
        id: id,
        type: menus[id].type
      })

      store.when(id).updated(product => {
        // 製品に何らかの変更が生じた際に呼び出さされる
        console.log('[updated]', product)
        this.emit('updated', product)
      })
      store.when(id).approved(product => {
        // 製品の注文が承認されると呼び出される
        // ここで product.finish() すると validator が呼びされなくなるので注意
        console.log('[approved]', product)
        product.verify()
        this.emit('approved', product)
      })
      store.when(id).verified(product => {
        // 領収書の検証に成功すると呼び出される
        console.log('[verified]', product)
        product.finish()
        this.emit('verified', product)
      })
      store.when(id).unverified(product => {
        // 領収書の検証に失敗すると呼び出される
        product.finish()
        this.emit('unverified')
      })
      store.when(id).downloaded(product => {
        // コンテンツのダウンロードが正常に完了すると呼び出される
        product.finish()
        this.emit('downloaded')
      })
    }

    store.error(err => {
      this.emit('error', err)
    })
    store.ready(() => {
      // ストアを使用できる状態になると呼び出される
      this.emit('ready')
    })

    // 2回以上呼び出すとサインインダイアログが毎回呼び出されるので1回しか呼び出さない
    if (!InAppPurhcase.refreshedStore) {
      store.refresh()
      InAppPurhcase.refreshedStore = true
    }
  }

  /**
   * 決済の成否判定
   * async にすると戻り値が Promise になってしまい呼び出されなくなる
   */
  validator(product, callback) {
    console.log('[validator]', product, this)
    Payment.reportAppPaymentValidator(product)
      .then(data => {
        this.emit('validator', { product: product, data: data })
        if (data.result === 'OK') {
          callback(true, product)
        } else {
          // 承認済みの transaction が繰り返しサーバに POST されるのを防ぐ
          if (product.state === store.APPROVED) {
            console.log('[validator] Approved product. run "product.finish()"')
            product.finish()
          }
          callback(false, 'Impossible to proceed with validation')
        }
      })
      .catch(err => {
        // "エラーで"承認済みの transaction が繰り返しサーバに POST されるのを防ぐ
        console.log('[validator] Approved product. run "product.finish()"')
        product.finish()
        this.emit('validator', { product: product, error: err })
      })
  }
}
